(function () {
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  var popup = null;
  var overlay = null;
  var dialog = null;
  var lastFocusedElement = null;

  function init() {
    popup = document.querySelector('[data-social-popup]');
    if (!popup) return;

    overlay = popup.querySelector('[data-social-popup-overlay]');
    dialog = popup.querySelector('[data-social-popup-dialog]');

    popup.querySelectorAll('[data-social-popup-close]').forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }

    // Delegated listener: works even if the trigger lives in the footer,
    // rendered separately from the popup markup itself.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-social-popup-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openPopup(trigger);
    });
  }

  function openPopup(trigger) {
    if (!popup || popup.classList.contains('is-open')) return;

    lastFocusedElement = trigger || document.activeElement;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('social-popup-open');
    document.addEventListener('keydown', handleKeydown);

    requestAnimationFrame(function () {
      var focusable = dialog ? dialog.querySelectorAll(FOCUSABLE_SELECTOR) : [];
      if (focusable.length) {
        focusable[0].focus();
      } else if (dialog) {
        dialog.focus();
      }
    });
  }

  function closePopup() {
    if (!popup || !popup.classList.contains('is-open')) return;

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('social-popup-open');
    document.removeEventListener('keydown', handleKeydown);

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
    lastFocusedElement = null;
  }

  function handleKeydown(event) {
    if (event.key === 'Escape') {
      closePopup();
      return;
    }

    if (event.key !== 'Tab' || !dialog) return;

    var focusable = dialog.querySelectorAll(FOCUSABLE_SELECTOR);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
